import { advertisingAllowed } from './privacyConsent';
/**
 * Meta Pixel (Facebook) chargé UNIQUEMENT après consentement publicitaire
 * explicite (bandeau cookies) et JAMAIS dans l'application native (marqueur
 * « G1SportNative » du User-Agent), pour rester conforme au RGPD et aux règles
 * de suivi de l'App Store (ATT / App Privacy).
 *
 * Consentement stocké dans localStorage sous `g1_ad_consent` :
 *   'granted' | 'denied' (absent = pas encore choisi).
 */
const PIXEL_ID = '2212527899335281';
export const AD_CONSENT_KEY = 'g1_ad_consent';

declare global {
  interface Window { fbq?: (...args: any[]) => void; _fbq?: any; }
}

let injected = false;

export const isNativeUA = (): boolean =>
  typeof navigator !== 'undefined' && navigator.userAgent.indexOf('G1SportNative') !== -1;

export const adConsentGranted = (): boolean => {
  return advertisingAllowed();
};

/** Injecte le script Meta et enregistre la 1re PageView. Idempotent. */
export function loadMetaPixel(): void {
  if (injected) return;
  if (isNativeUA()) return;          // jamais dans l'app native
  if (!adConsentGranted()) return;   // jamais sans consentement
  injected = true;

  /* eslint-disable */
  // Snippet officiel Meta.
  (function (f: any, b: any, e: string, v: string) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    const t = b.createElement(e); t.async = true; t.src = v;
    const s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq && window.fbq('init', PIXEL_ID);
  window.fbq && window.fbq('track', 'PageView');
}

/** Rejoue une PageView (navigation SPA), si le pixel est actif. */
export function metaPageView(): void {
  if (advertisingAllowed() && injected && window.fbq) window.fbq('track', 'PageView');
}

/** Enregistre le consentement et charge (ou non) le pixel en conséquence. */
export function setAdConsent(granted: boolean): void {
  try { localStorage.setItem(AD_CONSENT_KEY, granted ? 'granted' : 'denied'); } catch { /* ignore */ }
  if (granted) loadMetaPixel();
}
